import styled from "@emotion/styled";

export const StyledBoldTypography = styled("span")(({ theme }) => ({
    fontWeight: "bold"
}))